import { defineStore } from 'pinia';
import fileUploadAPI from '@/api/fileUpload';

export const useFileUploadStore = defineStore('fileUpload', () => {
  const uploadFile = async (module: string, file: File): Promise<string> => {
    try {
      return await fileUploadAPI.uploadFile(module, file);
    } catch (error) {
      console.error(`[Upload] Error al subir archivo en módulo ${module}:`, error);
      throw error;
    }
  };

  return {
    uploadFile,
  };
});
